import {
    Component,
    ElementRef
} from '@angular/core';

import * as Screeps from '@screeps/map';

import { default as RESOURCES } from '../../market.module/resource';

import { ApiService } from '../../core/upgraded-providers';

const MARGIN = 24;

@Component({
    selector: 'app-world-tooltip',
    templateUrl: './tooltip.component.pug',
    styleUrls: ['./tooltip.component.less']
})
export class TooltipComponent {
    RESOURCES = RESOURCES;

    data: any = {};

    isNovice: boolean = false;
    isRespawnArea: boolean = false;
    isOutOfBorders: boolean = false;
    isOpenTime: boolean = false;

    API: string;

    constructor(
        private _ref: ElementRef,
        private _apiSrv: ApiService
    ) {
        this.API = this._apiSrv.options.apiUrl;
        this.hide();
    }

    setData(data) {
        this.data = data;

        this.isNovice = Screeps.isNovice(data);
        this.isRespawnArea = Screeps.isRespawnArea(data);
        this.isOutOfBorders = Screeps.isOutOfBorders(data);
        this.isOpenTime = Screeps.isOpenTime(data);
    }

    setPosition([x, y]) {
        const width = this._ref.nativeElement.offsetWidth;
        const height = this._ref.nativeElement.offsetHeight;

        const pWidth = this._ref.nativeElement.parentElement.clientWidth;
        const pHeight = this._ref.nativeElement.parentElement.clientHeight;

        if ((x + width + MARGIN / 2) > pWidth) {
            x = x - width - MARGIN;
        }

        if ((y + height + MARGIN / 2) > pHeight) {
            y = y - height - MARGIN;
        }

        this._ref.nativeElement.style.top = `${ y }px`;
        this._ref.nativeElement.style.left = `${ x }px`;
    }

    hide() {
        this._ref.nativeElement.style.display = 'none';
    }

    show() {
        this._ref.nativeElement.style.display = 'block';
    }
}
